module.exports = __webpack_public_path__ + "assets/img/wifi.2d106f72.png";